import { AppContext } from "@/components/AppContext";
import { getUserData } from "@/firebase/firestore/getUserData";
import useUser from "@/hooks/useUser";
import { useContext, useEffect, useState } from "react";
import { icons } from "./icons";

export default function Favs({ children, className }) {
	const { setShowFavs } = useContext(AppContext);
	const { user } = useUser();
	const [cnt, setCnt] = useState(0);
	const [loading, setLoading] = useState(true);
	useEffect(() => {
		if (user?.uid) {
			getUserData(user?.uid, true).then((r) => {
				const { madeBy } = r;
				setCnt(madeBy);
				setLoading(false);
			});
		} else {
			setLoading(false);
		}
	}, [user]);

	return (
		<div
			className={className}
			onClick={() => setShowFavs((s) => (!s ? cnt : false))}
		>
			{children}
			{user &&
				(loading ? (
					<div className="animate-spin">{icons.loader}</div>
				) : (
					<div className="text-accent-400">{cnt.length}</div>
				))}
		</div>
	);
}
